import { FilterCombobox } from './FilterCombobox'

type SuggestTextFieldProps = {
  label: string
  value: string
  suggestions: string[]
  onChange: (value: string) => void
  listId?: string
  placeholder?: string
  className?: string
  disabled?: boolean
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode']
}

/** Searchable dropdown in the same style as catalog «Категория». */
export const SuggestTextField = ({
  label,
  value,
  suggestions,
  onChange,
  placeholder,
  className,
  disabled = false,
}: SuggestTextFieldProps) => (
  <FilterCombobox
    className={className}
    label={label}
    value={value}
    options={suggestions}
    placeholder={placeholder}
    disabled={disabled}
    listAllOnFocus
    onChange={onChange}
  />
)
